import React, { useState } from 'react';
import LogoAncona from '../assets/img/LogoAncona.png';
type Tier = {
  segmento: string;
  rango: string;
  nivel: string;
  descuento: string;
  borderClass: string;
  badgeClass: string;
  premium?: boolean;
};

const tiers: Tier[] = [
  {
    segmento: 'Nivel 1',
    rango: '$15,001 - $30,000',
    nivel: 'Encendido',
    descuento: '13%',
    borderClass: 'border-outline-variant',
    badgeClass: 'bg-outline-variant text-on-surface-variant',
  },
  {
    segmento: 'Nivel 2',
    rango: '$30,001 - $60,000',
    nivel: 'Combustión',
    descuento: '15%',
    borderClass: 'border-tertiary-container',
    badgeClass: 'bg-tertiary-container text-tertiary-fixed',
  },
  {
    segmento: 'Nivel 3',
    rango: '>$60,001',
    nivel: 'En Marcha',
    descuento: '18%',
    borderClass: 'border-secondary-container',
    badgeClass: 'bg-secondary-container text-white'
  }
];

type PlanLealtadProps = {
  onActivate?: () => void;
};

const PlanLealtad: React.FC<PlanLealtadProps> = ({ onActivate }) => {

  const handleActivate = () => {
    if (onActivate) {
      onActivate();
      return;
    }
  };

  return (
    <div className="bg-background text-on-background min-h-screen">
      <header className="flex items-center w-full px-4 h-16 bg-surface border-b border-outline-variant fixed top-0 z-50 justify-center">
        <img 
          src={LogoAncona }
          alt="Ancona Pro Logo" 
          className="h-10 w-auto object-contain" 
        />
      </header>

      <main className="pt-20 px-4 max-w-4xl mx-auto">
        <section className="mt-lg">
          <div className="relative overflow-hidden rounded-xl bg-primary-container p-lg mb-lg text-on-primary">
            <div className="absolute right-0 top-0 opacity-10">
              <span className="material-symbols-outlined text-[120px]">military_tech</span>
            </div>
            <h3 className="text-headline-md font-headline-md mb-xs">
              ¡Bienvenido a la familia de clientes Ancona Pro!
            </h3>
            <p className="text-body-md text-on-primary-container opacity-90">
              Súbete a la pista Ancona a través de este “Programa de Beneficios”, diseñado especialmente para premiar tu preferencia por Refaccionaria Ancona Autopartes 
            </p>
          </div>
        </section>

        {/* <section className="mb-xl">
          <div className="bg-white rounded-xl benefit-card-shadow border-l-4 border-secondary overflow-hidden">
            <div className="flex flex-col md:flex-row">
              <div className="bg-secondary text-white flex flex-col items-center justify-center p-lg md:w-44 md:flex-shrink-0">
                <span className="text-label-bold font-label-bold uppercase opacity-90">
                  Tu descuento
                </span>
                <div className="flex items-baseline mt-xs">
                  <span className="text-[56px] leading-none font-headline-xl font-black">
                    {descuento || '__'}
                  </span>
                  <span className="text-headline-md font-headline-md ml-1">%</span>
                </div>
                <span className="text-body-sm font-body-sm opacity-90 mt-xs">
                  directo en todas tus compras
                </span>
              </div>

              <div className="flex-1 p-lg">
                <div className="flex items-start gap-base mb-md">
                  <span className="material-symbols-outlined text-primary">event_available</span>
                  <div>
                    <p className="text-label-bold font-label-bold uppercase text-outline tracking-widest">
                      Vigencia
                    </p>
                    <p className="text-body-md font-body-md text-on-surface mt-xs">
                      Del{' '}
                      <span className="font-bold text-primary">{formatDate(startDate)}</span>
                      {' '}al{' '}
                      <span className="font-bold text-primary">{formatDate(endDate)}</span>
                    </p>
                  </div>
                </div>

                <p className="text-body-sm font-body-sm text-on-surface-variant mb-md">
                  Este es solo el comienzo de todos los beneficios exclusivos que disfrutarás como
                  miembro de nuestro programa.
                </p>

                <div className="flex items-start gap-base bg-surface-container-low rounded-lg p-md">
                  <span className="material-symbols-outlined text-secondary">smartphone</span>
                  <p className="text-body-sm font-body-sm text-on-surface">
                    Aplica tu descuento fácilmente en tu próxima compra proporcionando tu{' '}
                    <span className="font-bold text-primary">número de cliente</span> (número de
                    celular).
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section> */}

        <section className="mb-xl">
          <h4 className="text-label-bold font-label-bold uppercase text-outline mb-md tracking-widest">
            Beneficios exclusivos para miembros de la Familia Ancona PRO
          </h4>
          <div className="bento-grid">
            <div className="bg-surface-container-lowest p-md rounded-xl tier-card border-t-4 border-secondary">
              <span className="material-symbols-outlined text-secondary mb-xs">percent</span>
              <p className="text-label-bold font-label-bold text-on-surface">
                Descuentos exclusivos
              </p>
            </div>
            <div className="bg-surface-container-lowest p-md rounded-xl tier-card border-t-4 border-primary">
              <span className="material-symbols-outlined text-primary mb-xs">visibility</span>
              <p className="text-label-bold font-label-bold text-on-surface">
                Visitas de seguimiento a tu taller
              </p>
            </div>
            <div className="bg-surface-container-lowest p-md rounded-xl tier-card border-t-4 border-tertiary-container">
              <span className="material-symbols-outlined text-on-tertiary-container mb-xs">
                confirmation_number
              </span>
              <p className="text-label-bold font-label-bold text-on-surface">Rifas para clientes excepcionales</p>
            </div>
            <div className="bg-surface-container-lowest p-md rounded-xl tier-card border-t-4 border-outline">
              <span className="material-symbols-outlined text-outline mb-xs">verified</span>
              <p className="text-label-bold font-label-bold text-on-surface">Certificaciones Especializadas</p>
            </div>
          </div>
        </section>

        <section className="mb-xl">
          <div className="relative bg-primary text-on-primary rounded-xl overflow-hidden flex flex-col md:flex-row items-stretch">
            <div className="absolute -right-6 -top-6 opacity-10 pointer-events-none">
              <span className="material-symbols-outlined text-white text-[180px]">trending_up</span>
            </div>
            <div className="bg-secondary flex flex-col items-center justify-center px-lg py-md md:py-lg md:w-40 md:flex-shrink-0">
              <span className="text-[64px] leading-none font-headline-xl font-black text-white">
                3
              </span>
              <span className="text-label-bold font-label-bold uppercase tracking-widest text-white mt-xs">
                Meses
              </span>
            </div>
            <div className="relative flex-1 p-lg flex flex-col justify-center">
              <p className="text-label-bold font-label-bold uppercase tracking-widest text-secondary-fixed-dim mb-xs">
                Próxima evaluación
              </p>
              <p className="text-body-md font-body-md leading-relaxed">
                Al concluir tus primeros{' '}
                <span className="font-bold">3 meses</span>, te asignaremos un{' '}
                <span className="font-bold text-secondary-fixed-dim">
                  nuevo nivel de descuento
                </span>{' '}
                con base en la siguiente tabla.
              </p>
            </div>
          </div>
        </section>

        <section className="mb-xl">
          <div className="space-y-sm">
            <div className="hidden md:grid grid-cols-4 px-md py-xs text-label-bold font-label-bold text-outline uppercase">
              <div>Segmento</div>
              <div>Rango de Compra</div>
              <div>Nivel</div>
              <div className="text-right">Descuento</div>
            </div>

            {tiers.map((tier) => (
              <div
                key={tier.segmento}
                className={`bg-surface-container-low rounded-xl p-md flex flex-col md:grid md:grid-cols-4 items-center gap-2 border-l-4 ${tier.borderClass} hover:bg-surface-variant transition-colors ${
                  tier.premium ? 'relative overflow-hidden' : ''
                }`}
              >
                {tier.premium && (
                  <div className="absolute right-0 top-0 bg-secondary text-white text-[8px] px-2 py-1 rotate-45 translate-x-4 -translate-y-1 font-bold">
                    PREMIUM
                  </div>
                )}
                <div className="flex items-center gap-2 w-full md:w-auto">
                  <span
                    className={`${tier.badgeClass} text-[10px] px-2 py-0.5 rounded-full font-bold uppercase`}
                  >
                    {tier.segmento}
                  </span>
                  <span className="md:hidden text-label-bold text-outline">{tier.nivel}</span>
                </div>
                <div className="text-body-md font-bold text-primary w-full md:w-auto">
                  {tier.rango}
                </div>
                <div className="hidden md:block text-body-md font-bold text-on-surface">
                  {tier.nivel}
                </div>
                <div className="text-headline-md font-headline-md text-secondary md:text-right w-full md:w-auto">
                  {tier.descuento}
                </div>
              </div>
            ))}
          </div>
          <p className="mt-md text-body-sm text-outline italic">
            *Si logras incrementar tus compras durante este periodo, podrás acceder automáticamente
            a un mayor porcentaje de descuento.
          </p>
        </section>

        <section className="mb-xl space-y-md">
          <div className="bg-surface-container-low rounded-xl p-md flex items-start gap-base border-l-4 border-primary">
            <span className="material-symbols-outlined text-primary">support_agent</span>
            <p className="text-body-sm font-body-sm text-on-surface">
              Además, continuaremos brindándote{' '}
              <span className="font-bold text-primary">visitas de atención y seguimiento</span>{' '}
              para ayudarte a crecer.
            </p>
          </div>

          <div className="bg-error-container/40 rounded-xl p-md flex items-start gap-base border-l-4 border-error">
            <span className="material-symbols-outlined text-error">info</span>
            <div>
              <p className="text-label-bold font-label-bold uppercase tracking-widest text-error mb-xs">
                Nota importante
              </p>
              <p className="text-body-sm font-body-sm text-on-surface">
                Los descuentos{' '}
                <span className="font-bold">no aplican</span> con otras promociones, ventas de
                acumuladores y Compras Express.
              </p>
            </div>
          </div>

          <p className="text-body-sm font-body-sm text-outline italic px-md">
            *Los rangos de compra mensual se calculan usando el valor de la venta antes de IVA.
          </p>
        </section>

        <section className="mb-xl">
          <div className="relative bg-sky-200/60 backdrop-blur-sm text-primary rounded-xl p-lg flex items-center gap-md overflow-hidden border border-sky-300/40">
            <div className="flex-shrink-0 w-14 h-14 rounded-full bg-white/80 flex items-center justify-center">
              <span className="material-symbols-outlined text-primary">smartphone</span>
            </div>
            <div className="relative">
              <p className="text-label-bold font-label-bold uppercase tracking-widest text-sky-700 mb-xs">
                Recuerda
              </p>
              <p className="text-body-md font-body-md leading-relaxed">
                Tu{' '}
                <span className="font-bold">número de celular registrado</span> es también tu{' '}
                <span className="font-bold">número de cliente</span> y es válido en{' '}
                <span className="font-bold">cualquier sucursal</span>.
              </p>
            </div>
          </div>
        </section>

        <section className="mb-xl text-center px-md">
          <span className="material-symbols-outlined text-secondary text-[40px] mb-xs">
            favorite
          </span>
          <p className="text-headline-md font-headline-md text-primary mb-xs">
            ¡Gracias por elegirnos!
          </p>
          <p className="text-body-md font-body-md text-on-surface-variant">
            Estamos felices de tenerte en esta{' '}
            <span className="font-bold text-secondary">Gran Familia</span>.
          </p>
        </section>

        <section className="mb-xl">
          <details className="bg-surface-container-low rounded-xl border border-outline-variant group">
            <summary className="cursor-pointer p-md flex items-center justify-between gap-base list-none">
              <div className="flex items-center gap-base">
                <span className="material-symbols-outlined text-outline">shield</span>
                <span className="text-label-bold font-label-bold uppercase tracking-widest text-outline">
                  Aviso de privacidad – Programa de lealtad
                </span>
              </div>
              <span className="material-symbols-outlined text-outline transition-transform group-open:rotate-180">
                expand_more
              </span>
            </summary>
            <div className="px-md pb-md">
              <p className="text-body-sm font-body-sm text-on-surface-variant">
                Esta política de privacidad describe cómo se recopila, utiliza y comparte su
                información personal, así como los Derechos ARCO, cuando se inscribe al programa de
                lealtad denominado{' '}
                <span className="font-bold text-primary">ANCONA PRO</span>. Disponible en{' '}
                <a
                  href="https://www.anconaautopartes.com/politica-de-privacidad"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-secondary font-bold underline hover:opacity-80"
                >
                  anconaautopartes.com/politica-de-privacidad
                </a>
                .
              </p>
            </div>
          </details>
        </section>

        <section className="mt-xl text-center pb-xl">
          <button
            type="button"
            onClick={handleActivate}
            className="w-full py-4 bg-secondary text-white font-headline-md rounded-xl shadow-lg hover:bg-secondary-container transition-all active:scale-95 flex items-center justify-center gap-2"
          >
            <span className="material-symbols-outlined">bolt</span>
            ACTIVAR MI BENEFICIO
          </button>
          <p className="mt-md text-body-sm text-outline">
            Al activar, aceptas los términos y condiciones del programa de socios Ancona Pro.
          </p>
        </section>
      </main>
    </div>
  );
};

export default PlanLealtad;
